const reported = new WeakSet<object>()

export function markReportedToSentry(error: unknown) {
  if (error && typeof error === 'object') reported.add(error)
}

export function isReportedToSentry(error: unknown) {
  return !!error && typeof error === 'object' && reported.has(error)
}
